/**
 * Website Creation tier pricing - display values mirror the Stripe Payment Links
 * configured in `backend/stripe_integration.WEBSITE_CREATION_LINKS`.
 *
 * Two tiers, each priced per currency (GBP / EUR / USD).
 */

export const WEBSITE_CREATION_TIERS = [
  {
    id: 'foundation',
    label: 'Foundation Website',
    description: 'Launch your professional website quickly',
    pages: '3-5 pages',
    price: { gbp: 433, eur: 499, usd: 584 },
  },
  {
    id: 'growth',
    label: 'Growth Website',
    description: 'Built for growth and conversions',
    pages: '8-12 pages',
    featured: true,
    price: { gbp: 952, eur: 1099, usd: 1288 },
  },
];

export const WC_CURRENCY_SYMBOL = { gbp: '£', eur: '€', usd: '$' };
